import { Skeleton as MuiSkeleton } from '@mui/material';
import styled from 'styled-components';

const CategoriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const VideoCategoryCardContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  max-width: 720px;
  width: 100%;
`;

const SkeletonContainer = styled.div`
  max-width: 720px;
  width: 100%;
`;

const Skeleton = styled(MuiSkeleton)`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export { CategoriesContainer,
  VideoCategoryCardContainer,
  Skeleton,
  SkeletonContainer };
